export const dailyPuzzleSchema = {
  type: 'daily-puzzle',
  label: 'Daily Puzzle',
  description: 'Lichess puzzle of the day — visitors solve it on your site',
  icon: 'Puzzle',
  defaultContent: {
    title: 'Daily Puzzle',
    matchThemeSquares: false,
    style: {},
  },
  fields: [
    { name: 'title', label: 'Section Title', type: 'text', placeholder: 'Daily Puzzle' },
    { name: 'matchThemeSquares', label: 'Match Theme Color', type: 'checkbox' },
  ],
};
